import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import '@fontsource-variable/archivo';
import '@fontsource-variable/archivo-narrow';
import '@fontsource-variable/instrument-sans';
import '@fontsource-variable/jetbrains-mono';

import './styles/tokens.css';
import './styles/base.css';
import './styles/print.css';

import App from './App';
import { startUpdates } from './lib/sw';
import { lockZoom } from './lib/viewport';

const base = import.meta.env.BASE_URL.replace(/\/$/, '');

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <BrowserRouter basename={base || undefined}>
      <App />
    </BrowserRouter>
  </StrictMode>,
);

// Keeps an installed app from sitting on an old build after a resume.
startUpdates();
lockZoom();
